import { Home, Gem, FlaskConical, MapPin } from "lucide-react";
import { WHY_ITEMS } from "../data/content";
import { SectionTitle } from "./Brand";
import { Reveal } from "./Reveal";

const ICONS = { Home, Gem, FlaskConical, MapPin };

const WhyCml = () => (
    <section id="pourquoi" data-testid="why-section" className="py-24 sm:py-32">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
            <Reveal>
                <SectionTitle
                    eyebrow="Pourquoi Clean My Life"
                    title="L'exigence du detailing, sans vous déplacer"
                />
            </Reveal>
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                {WHY_ITEMS.map((item, i) => {
                    const Icon = ICONS[item.icon];
                    return (
                        <Reveal key={item.title} delay={i * 0.1}>
                            <div
                                data-testid={`why-item-${i + 1}`}
                                className="card-line group h-full rounded-3xl bg-panel p-7 transition-shadow duration-500 hover:glow-soft"
                            >
                                <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-2xl border border-neon/25 bg-neon/5 text-neon transition-transform duration-500 group-hover:scale-110">
                                    <Icon size={22} strokeWidth={1.8} />
                                </div>
                                <h3 className="font-display text-lg font-bold text-white">
                                    {item.title}
                                </h3>
                                <p className="mt-2 text-sm leading-relaxed text-slate-400">
                                    {item.desc}
                                </p>
                            </div>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
);

export default WhyCml;
